import type { Infer } from 'superstruct';
import { omit } from 'superstruct';

import { ViewColumnTemplateDto } from './view-column-template.dto';

export const AddColumnTemplateDto = omit(ViewColumnTemplateDto, [
	'id',
	'createdAt',
	'updatedAt',
]);
export type AddColumnTemplateDto = Infer<typeof AddColumnTemplateDto>;

export const EditColumnTemplateDto = omit(ViewColumnTemplateDto, [
	'id',
	'createdAt',
	'updatedAt',
	'columnType',
]);
export type EditColumnTemplateDto = Infer<typeof EditColumnTemplateDto>;
